import {
  GRAPHQLFilters,
  FilterValue,
  NestedValue,
  NestedFilter,
  FilterValueType,
  GRAPHQLFilterInput,
} from "~/types";

/**
 * Builds GraphQL filters with support for various operators and nested fields
 */
export const getGraphqlFilters = (fields: GRAPHQLFilterInput) => {
  let filters: GRAPHQLFilters = {};

  const processNestedValue = (
    value: FilterValueType | FilterValue | NestedValue
  ): FilterValue | NestedFilter => {
    if (
      typeof value === "string" ||
      typeof value === "number" ||
      typeof value === "boolean"
    ) {
      return { eq: value };
    } else if (
      Array.isArray(value) &&
      value.length === 2 &&
      ((typeof value[0] === "string" && typeof value[1] === "string") ||
        (typeof value[0] === "number" && typeof value[1] === "number"))
    ) {
      return { between: value } as FilterValue;
    } else if ("operator" in value && "value" in value) {
      return { [value.operator as string]: value.value } as FilterValue;
    } else {
      // Handle nested objects
      const nestedFilters: NestedFilter = {};
      Object.entries(value).forEach(([nestedKey, nestedValue]) => {
        nestedFilters[nestedKey] = processNestedValue(nestedValue);
      });
      return nestedFilters;
    }
  };

  const addFilter = (
    key: string,
    value: FilterValueType | FilterValue | NestedValue
  ): any => {
    filters = {
      ...filters,
      [key]: processNestedValue(value),
    };
    return filters[key as keyof GRAPHQLFilters];
  };

  Object.entries(fields).forEach(([key, value]) => {
    if (value !== undefined) {
      addFilter(key, value);
    }
  });

  return filters;
};
